module.exports = __webpack_public_path__ + "static/media/Mapa-RMC.svg.74864564.png";